import { render, staticRenderFns } from "./editarCapacitacion.vue?vue&type=template&id=2ab739a9"
import script from "./editarCapacitacion.vue?vue&type=script&lang=js"
export * from "./editarCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports